module.exports = __webpack_public_path__ + "static/media/Tupe8.a43043a0.webp";